module.exports = __webpack_public_path__ + "img/25_55.d89f7fd9.png";